// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 116) return "static/chunks/116-9e643628a70c4155.js";
	if (chunkId === 586) return "static/chunks/586-042bdbce7035356c.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 505 ? "ada298ba" : chunkId) + "." + {"29":"58b34d81d8984bd5","192":"5991d1daf437fc53","302":"013d013f1516046a","505":"b4f3916d6260cb6f","641":"b0a91cb2445032a6","758":"54a4387c9a414864","971":"096ab761880fdcb8"}[chunkId] + ".js";
};